import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Col } from "reactstrap";
import Toast from "../helpers/Toast";
import { AssistanceService } from "../services/AssistanceService";
import ButtonComponent from "./ButtonComponent";
import { SelectItemsProps } from "./Select2Component";
import SelectComponent from "./SelectComponent";
import { useIntl } from "react-intl";

export type TechnicanCompontentProps = {
    OnClick: (technician: string) => void;
    OnCancel: () => void;
    Technician: string;
    IsOpen: boolean;
};

function TechnicanCompontent(props: TechnicanCompontentProps) {
    const [technicians, setTechnicians] = useState<SelectItemsProps[]>([]);
    const [technician, setTechnician] = useState<string>(props.Technician);
    const service = new AssistanceService();

    useEffect(() => {
        if (props.IsOpen === true) {
            getTechnicians();
        }
    }, [props.IsOpen]);

    const getTechnicians = async () => {
        const list: SelectItemsProps[] = [];
        var response = await service.GetWorkshopTechniciansWithCode();

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.id,
                label: element.name,
            };
            if (element.name === props.Technician) {
                setTechnician(item.value);
            }
            list.push(item);
        });

        setTechnicians(list);
    };

    const intl = useIntl();

    return (
        <Dialog open={props.IsOpen}>
            <DialogTitle>{props.Technician === "" ? "Atribuir Técnico" : "Alterar Técnico"}</DialogTitle>
            <DialogContent>
                <SelectComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    label={"Técnico"}
                    selectedItemValue={technician}
                    items={technicians}
                    onChange={(t: string) => {
                        setTechnician(t);
                    }}
                />
            </DialogContent>
            <DialogActions className="loginbuttons">
                <div style={{ display: "flex", justifyContent: "space-between", margin: "10px", paddingLeft: "5px" }}>
                    <Col md={6} sm={6} xs={6} lg={6}>
                        <ButtonComponent
                            onClick={() => props.OnClick(technician)}
                            className="enteraccount"
                            style={{ width: "97%", borderRadius: "5px" }}
                            text={intl.formatMessage({ id: props.Technician === null ?
                                 "TechnicianComponent.Assign" :
                                  "TechnicianComponent.Update"})}
                            />
                    </Col>
                    <Col md={6} sm={6} xs={6} lg={6}>
                        <ButtonComponent
                            onClick={props.OnCancel}
                            className="enteraccount"
                            style={{ width: "97%", borderRadius: "5px" }}
                            text={intl.formatMessage({ id: "TechnicianComponent.Cancel" })}
                        />
                    </Col>
                </div>
            </DialogActions>
        </Dialog>
    );
}

export default TechnicanCompontent;
